import axios from "axios";
import { liveURL } from "../../constants/Consts";

const MAIN_URL = `${liveURL}/v1/adminMatbuaat`;
const CREATE_BOOK = `${MAIN_URL}/createBook`;
const GET_BOOKS = `${MAIN_URL}/getBooks`;
const GET_BOOK_BY_ID = (bookId) => `${MAIN_URL}/getBook/${bookId}`;
const UPDATE_BOOK = (bookId) => `${MAIN_URL}/updateBook/${bookId}`;
const DELETE_BOOK = `${MAIN_URL}/deleteBook`;


// Create a new book
export async function createBooK(token, data) {
    try {
      const response = await axios.post(CREATE_BOOK, data, {
        headers: { token: token },
      });
      return response.data;
    } catch (error) {
      console.log("Error creating Book:", error);
      return { Result: false, Msg: "Error creating Book" };
    }
  }
  // Get all books
export async function getBooks(token) {
    try {
      const response = await axios.get(GET_BOOKS, {
        headers: { token: token },
      });
      return response.data;
    } catch (error) {
      console.log("Error fetching books:", error);
      return { Result: false, Msg: "Error fetching books" };
    }
  }
  // Get book by ID
export async function getBookById(token, bookId) {
    try {
        const response = await axios.get(GET_BOOK_BY_ID(bookId), {
            headers: { token: token },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching book:", error?.response?.data || error.message);
        return { Result: false, Msg: error?.response?.data?.message || "Error fetching book" };
    }
}

// Update book
export async function updateBook(token, bookId, data) {
    try {
        const response = await axios.put(UPDATE_BOOK(bookId), data, {
            headers: { token: token },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating book:", error?.response?.data || error.message);
        return { Result: false, Msg: error?.response?.data?.message || "Error updating book" };
    }
}

export async function deleteBook(token, id) {
  try {
    const response = await axios.delete(`${DELETE_BOOK}/${id}`, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error deleting Mujjalah:", error);
    return { Result: false, Msg: "Error deleting Mujjalah" };
  }
}